module.exports = __webpack_public_path__ + "static/media/ApiBooking.afb1b901.svg";